<script>
import Error from '@/components/views/Error';

export default {
  name: 'App',
  components: {
    Error
  },
  props: {
    statusCode: Number
  },
  mounted() {
    // Prevent accidental drops from leaving the current page
    document.addEventListener('dragover', event => event.preventDefault());
    document.addEventListener('dragleave', event => event.preventDefault());
    document.addEventListener('drop', event => event.preventDefault());
  },
  metaInfo() {
    return {
      titleTemplate: titleChunk => {
        const appName = this.$store.state.metadata.appName;
        return titleChunk ? `${titleChunk} | ${appName}` : appName;
      },
      meta: [{ name: 'apple-mobile-web-app-title', content: this.$store.state.metadata.appName }],
      link: [
        { rel: 'icon', href: this.$store.state.metadata.favicon },
        { rel: 'apple-touch-icon', href: this.$store.state.metadata.favicon }
      ]
    };
  }
};
</script>

<template>
  <div id="app">
    <!-- Router view -->
    <router-view v-if="statusCode === 200" :key="$route.fullPath" />

    <!-- App error -->
    <div v-else-if="statusCode">
      <error :status-code="statusCode" />
    </div>
  </div>
</template>

<style lang="scss">
// Global styles
@import '~animate.css/animate.css';
@import '~cropperjs/dist/cropper.css';
@import '@/styles/variables.scss';
@import '@/styles/element-ui.scss';
@import '@/styles/font-awesome.scss';
@import '@/styles/utilities/forms.scss';
@import '@/styles/utilities/tables.scss';
@import '@/styles/utilities/text.scss';
</style>
